const serveraddress = 'http://158.160.65.66'
// const serveraddress = 'http://127.0.0.1:8000'

class Api {
    constructor(url, headers) {
        this._url = url
        this._headers = headers
    }

    checkResponse(res) {
        return new Promise((resolve, reject) => {
            if (res.status === 204) {
                return resolve(res)
            }
            const func = res.status < 400 ? resolve : reject
            res.json().then(data => func(data))
        })
    }

    // tags

    getTags() {
        return fetch(
            `${serveraddress}/api/news/tag/`,
            {
                method: 'GET',
                headers: {
                    ...this._headers
                }
            }
        ).then(this.checkResponse)
    }

    // news

    getNews({
        page = 1,
        tags
    } = {}) {
        const tagsString = tags ? tags.filter(tag => tag.value).map(tag => `&tags=${tag.slug}`).join('') : ''
        return fetch(
            `${serveraddress}/api/news/?page=${page}&${tagsString}`,
            {
                method: 'GET',
                headers: {
                    ...this._headers,
                }
            }
        ).then(this.checkResponse)
    }

    getSingleNews({
        news_id
    }) {
        return fetch(
            `${serveraddress}/api/news/${news_id}/`,
            {
                method: 'GET',
                headers: {
                    ...this._headers,
                }
            }
        ).then(this.checkResponse)
    }

    // bulletins

    getBulletins() {
        return fetch(
            `${serveraddress}/api/bulletins/`,
            {
                method: 'GET',
                headers: {
                    ...this._headers
                }
            }
        ).then(this.checkResponse)
    }

    // schools

    getSeason() {
        return fetch(
            `${serveraddress}/api/seasons12/`,
            {
                method: 'GET',
                headers: {
                    ...this._headers
                }
            }
        ).then(this.checkResponse)
    }

    getSchools({ seasons } = {}) {
        const seasonsString = seasons ? seasons.filter(season => season.value).map(season => `&seasons=${season.season_number}`).join('') : ''
        return fetch(
            `${serveraddress}/api/schools/?${seasonsString}`,
            {
                method: 'GET',
                headers: {
                    ...this._headers
                }
            }
        ).then(this.checkResponse)
    }

    getSchoolsList({ seasons } = {}) {
        const seasonNumber = seasons ? seasons.filter(season_number => season_number.value).map(season => `&season_number=${season.season_number}`).join('') : ''
        console.log(seasonNumber);

        return fetch(
            `${serveraddress}/api/seasons_list/?${seasonNumber}`,
            {
                method: 'GET',
                headers: {
                    ...this._headers
                }
            }
        ).then(this.checkResponse)
    }
    // conferences

    getConferences() {
        return fetch(
            `${serveraddress}/api/conferences/`,
            {
                method: 'GET',
                headers: {
                    ...this._headers
                }
            }
        ).then(this.checkResponse)
    }

    // documents

    getDocuments() {
        return fetch(
            `${serveraddress}/api/documents/`,
            {
                method: 'GET',
                headers: {
                    ...this._headers
                }
            }
        ).then(this.checkResponse)
    }

    getCounter() {
        return fetch(
            `${serveraddress}/api/registration/get_counter/`,
            {
                method: 'GET',
                headers: {
                    ...this._headers
                }
            }
        ).then(this.checkResponse)
    }

    registrationConference({
        school_name,
        fio,
        region,
        job_place,
        job,
        phone,
        email
    }) {
        return fetch(
            `${serveraddress}/api/registration/`,
            {
                method: 'POST',
                headers: {
                    ...this._headers,
                },
                body: JSON.stringify({
                    school_name,
                    fio,
                    region,
                    job_place,
                    job,
                    phone,
                    email
                })
            }
        ).then(this.checkResponse)
    }

    registrationConferenceLite({
        school_name,
        fio,
        region = '-',
        job_place = '-',
        job = '-',
        phone = '-',
        email = '-'
    }) {
        return fetch(
            `${serveraddress}/api/registration/get_registration_lite/`,
            {
                method: 'POST',
                headers: {
                    ...this._headers,
                },
                body: JSON.stringify({
                    school_name,
                    fio,
                    region,
                    job_place,
                    job,
                    phone,
                    email
                })
            }
        ).then(this.checkResponse)
    }

    getRegistrationUsers({
        page = 1,
        limit = 20,
        tags,
        search = '',
    } = {}) {
        const token = localStorage.getItem('auth_token')
        const authorization = token ? { 'authorization': `Token ${token}` } : {}
        const tagsString = tags ? tags.map(tag => (tag.filter(item => item.value).map(item2 => `&tags=${item2.id}`).join(''))) : ''
        return fetch(
            `${serveraddress}/api/registration/?page=${page}&limit=${limit}&search=${search}&school_name=${tagsString}`,
            {
                method: 'GET',
                headers: {
                    ...this._headers,
                    ...authorization
                }
            }
        ).then(this.checkResponse)
    }

    removeUser({ user_id }) {
        const token = localStorage.getItem('auth_token')
        return fetch(
            `/api/registration/${user_id}/delete_user/`,
            {
                method: 'DELETE',
                headers: {
                    ...this._headers,
                    'authorization': `Token ${token}`
                }
            }
        ).then(this.checkResponse)
    }

    getFlatPage() {
        return fetch(
            `${serveraddress}/api/pages/`,
            {
                method: 'GET',
                headers: {
                    ...this._headers
                }
            }
        ).then(this.checkResponse)
    }

    // авторизация
    signin({ username, password }) {
        return fetch(
            `${serveraddress}/api/auth/token/login/`,
            {
                method: 'POST',
                headers: this._headers,
                body: JSON.stringify({
                    username, password
                })
            }
        ).then(this.checkResponse).catch((e) => {
            console.log(e);
            this.setState({
                isError: true,
                errorMessage: e.message
            })
        });
    }

    signout() {
        const token = localStorage.getItem('auth_token')
        return fetch(
            `${serveraddress}/api/auth/token/logout/`,
            {
                method: 'POST',
                headers: {
                    ...this._headers,
                    'authorization': `Token ${token}`
                }
            }
        ).then(this.checkResponse)
    }

    getUserData() {
        const token = localStorage.getItem('auth_token')
        return fetch(
            `${serveraddress}/api/users/me/`,
            {
                method: 'GET',
                headers: {
                    ...this._headers,
                    'authorization': `Token ${token}`
                }
            }
        ).then(this.checkResponse)
    }
}

export default new Api(process.env.API_URL || 'http://localhost:8000', { 'content-type': 'application/json' })
